/**
 * AnimatedCategoryIcon — ícone dos cards de categoria da homepage.
 *
 * TEMPORÁRIO por design: o glyph central será substituído por smilies oficiais
 * do xat. Para trocar, basta passar `children` — a caixa permanece.
 *
 * Sem glow externo nem bounce no hover.
 */

import { memo, type ReactNode } from 'react';
import { CmsCategoryIcon } from '@/components/painel/cms/cms-icons';
import { ORBITAL_ICON_BOX_STYLE } from '@/components/help-center/latest-power-shared';
import { cn } from '@/lib/utils';

export type AnimatedCategoryIconProps = {
  categoryId: string;
  icon: string;
  iconClassName?: string;
  className?: string;
  /** Slot para smilies oficiais do xat no futuro. */
  children?: ReactNode;
};

function AnimatedCategoryIconBase({
  icon,
  iconClassName,
  className,
  children,
}: AnimatedCategoryIconProps) {
  const glyph = children ?? (
    <CmsCategoryIcon name={icon} className={cn('h-7 w-7', iconClassName)} />
  );

  return (
    <div className={cn('relative mb-4 inline-flex', className)}>
      <div
        className="relative flex h-14 w-14 items-center justify-center overflow-hidden rounded-2xl"
        style={ORBITAL_ICON_BOX_STYLE}
      >
        <span
          className="pointer-events-none absolute inset-0 rounded-2xl bg-[radial-gradient(circle_at_50%_120%,rgba(3,0,35,0.45),transparent_60%)]"
          aria-hidden
        />
        <span className="relative">{glyph}</span>
      </div>
    </div>
  );
}

export const AnimatedCategoryIcon = memo(AnimatedCategoryIconBase);
